import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/job/${':jobId' | number}/sync`;

export type * from './requestModel';

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/sync`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/sync`;
